import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/reset.css';

document.addEventListener('contextmenu', (event) => {
  if (process.env.NODE_ENV !== 'development') {
    event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />
);
